import { TriangleAlert } from 'lucide-react';
import { formatPercent, formatPower, type SiteLive } from '@ste/shared';
import { Banner } from '../../components/ui.tsx';
import { t } from '../../i18n/index.ts';

/** clearly visible notice when the grid operator limits consumption (§14a EnWG) or feed-in */
export function HemsBanner({ live }: { live: SiteLive }) {
  return (
    <>
      {live.hems.dimmed && (
        <Banner
          tone="warm"
          title={t('grid.dimmedTitle')}
          icon={<TriangleAlert className="text-warm-text" size={22} />}
        >
          {t('grid.dimmedText')}
          {live.hems.maxConsumptionPower !== undefined && (
            <>
              {' '}
              {t('grid.limit')}: {formatPower(live.hems.maxConsumptionPower)}
            </>
          )}
        </Banner>
      )}
      {live.hems.curtailedPercent !== undefined && live.hems.curtailedPercent < 100 && (
        <Banner tone="muted" title={t('grid.curtailedTitle')}>
          {formatPercent(live.hems.curtailedPercent)}
        </Banner>
      )}
    </>
  );
}
